<template>
  <div class="preWarning">
    <el-tabs v-model="activateTab" @tab-click="handleTabClick">
      <el-tab-pane v-for="item in warningModules" :key="item.module" :name="item.module">
        <span slot="label"><span class="tabSpanStyle">{{ item.moduleName }}</span><span>(</span><span style="color: #f56c6c">{{ warningCounts[item.module] || 0 }}</span><span>)</span></span>
        <tab-warning :ref="item.module" :key="item.module" :module="item.module" @resetCount="resetLobCount" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { countTodoItemFunc } from '@/api/commonComponent'
import TabWarning from '@/views/dashboard/admin/components/WarningPending/components/tabWarning'

export default {
  name: 'WarningPending',
  components: { TabWarning },
  props: {
    warningModules: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isFirst: true,
      activateTab: 'paymentApply',
      warningCounts: { }
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.init()
    }
  },
  methods: {
    async init() {
      await this.resetLobCount()
      await this.refreshPage()
    },
    async resetLobCount() {
      await countTodoItemFunc().then(res => {
        this.warningCounts = res.data
      })
    },
    handleTabClick() {
      this.refreshPage()
    },
    async refreshPage() {
      if (this.activateTab && this.$refs[this.activateTab] && this.$refs[this.activateTab][0]) {
        this.$refs[this.activateTab][0].clearGrid()
        await this.$refs[this.activateTab][0].fetchData(true)
      }
    }
  }
}
</script>

<style lang="scss">
.preWarning{
  position: relative;
  .actions {
    position: absolute;
    right: 0;
    top:3px;
    z-index: 99;
    span {
      font-size: 14px;
    }
    i:before{
      font-size: 16px;
    }
  }
  .tabSpanStyle{
    font-size: 14px
  }
}
</style>
